import {
    UsersDirectorySearchFailureAction,
    UsersDirectorySearchRequestAction,
    UsersDirectorySearchSuccessAction,
    USERS_DIRECTORY_SEARCH_FAILURE,
    USERS_DIRECTORY_SEARCH_REQUEST,
    USERS_DIRECTORY_SEARCH_SUCCESS,
} from 'mk2/apps/users/containers/UsersDirectory/UsersDirectory.actions';
import { errorMessage } from 'mk2/reducers/errorMessage';
import { loadingState, LoadingState } from 'mk2/reducers/loadingState';

export interface UsersDirectoryState {
    usersStatsIds: number[];
    hasMore: boolean;
    loadingState: LoadingState;
    errorMessage: string;
}

export const initialUsersDirectoryState: UsersDirectoryState = {
    usersStatsIds: [],
    hasMore: false,
    loadingState: LoadingState.INIT,
    errorMessage: null,
};

type UsersDirectoryActions = UsersDirectorySearchRequestAction
    | UsersDirectorySearchSuccessAction
    | UsersDirectorySearchFailureAction;

const reducer = (state: UsersDirectoryState = initialUsersDirectoryState, action: UsersDirectoryActions) => {
    switch (action.type) {
        case USERS_DIRECTORY_SEARCH_SUCCESS:
            return {
                ...state,
                usersStatsIds: action.response.result.usersStats,
                hasMore: action.hasMore,
                loadingState: loadingState(undefined, action),
                errorMessage: errorMessage(undefined, action),
            };
        case USERS_DIRECTORY_SEARCH_REQUEST:
        case USERS_DIRECTORY_SEARCH_FAILURE:
            return {
                ...state,
                loadingState: loadingState(undefined, action),
                errorMessage: errorMessage(undefined, action),
            };
        default:
            return state;
    }
};

export default reducer;
